import { useState, useEffect } from 'react'
import { Button } from './components/ui/button.jsx'
import { Input } from './components/ui/input.jsx'
import { Textarea } from './components/ui/textarea.jsx'
import { Mail, Phone, MapPin, Play, X, Heading } from 'lucide-react'
import heroImage1 from './assets/Loop1.jpeg'
import heroImage2 from './assets/loop2.jpg'
import heroImage3 from './assets/loop3.jpg'
import heroImage4 from './assets/loop4.jpg'
import heroImage5 from './assets/loop5.jpg'
import heroImage6 from './assets/hero_image_6.png'
import bioPhoto from './assets/bio_photo.jpg'
import networkBg from './assets/networkbgmono.png'
import './App.css'
import thumbnaila1 from './assets/thumbnaila1.avif'
import thumbnaila2 from './assets/thumbnaila2.avif'
import thumbnaila3 from './assets/thumbnaila3.avif'
import thumbnaila4 from './assets/thumbnaila4.avif'
import thumbnaila5 from './assets/thumbnaila5.avif'
import thumbnaila6 from './assets/thumbnaila6.avif'
import thumbnaila7 from './assets/thumbnaila7.avif'
import thumbnaila8 from './assets/thumbnaila8.avif'
import thumbnaila9 from './assets/thumbnaila9.avif'
import thumbnaila10 from './assets/thumbnaila10.avif'
import thumbnaila11 from './assets/thumbnaila11.avif'
import thumbnaila12 from './assets/thumbnaila12.avif'
import Navbar from './components/Navbar.jsx'
import HeroSlider from './components/HeroSlider.jsx'
function App() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0)



  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  })

  const heroImages = [
    heroImage1,
    heroImage2,
    heroImage3,
    heroImage4,
    heroImage5,
  ]

  // // Hero image loop effect
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setCurrentImageIndex((prevIndex) =>
  //       prevIndex === heroImages.length - 1 ? 0 : prevIndex + 1
  //     )
  //   }, 4000) // Change image every 4 seconds

  //   return () => clearInterval(interval)
  // }, [heroImages.length])





  const documentaryVideos = [
    {
      id: 1,
      title: "The Program: Prison Detox,",
      heading: 'Discovery+',
      thumbnaila: thumbnaila1,
      thumbnailaURL: 'https://vimeo.com/1095758672/7ffc0fd015',
      vimeoId: '1095758672',
      vimeoHash: '7ffc0fd015',
      description: "Excerpts from Act 1 of the doc-series I created and sold to Discovery +. I was an Executive Producer as well as Lead Editor. The show was nominated for Best Docu-Reality Series at Realscreen 2023."
    },
    {
      id: 2,
      upperHeading:'Scenework from',
      title: "The Program: Prison Detox",
      thumbnaila: thumbnaila2,
      thumbnailaURL: 'https://vimeo.com/1095758977/add33bae23',
      vimeoId: '1095758977',
      vimeoHash: 'add33bae23',
      description: "More from The Program: Prison Detox showcasing emotional scenework around two of the shows’ most compelling characters, Angela and Cameron."
    },
    {
      id: 3,
      title: "The Case Of: JonBenet Ramsey,",
      heading: 'CBS',
      thumbnaila: thumbnaila3,
      thumbnailaURL: 'https://vimeo.com/1095758544/b3870e4737',
      vimeoId: '1095758544',
      vimeoHash: 'b3870e4737',
      description: "A high-production value true crime documentary revealing new clues about a very high-profile case."
    },
    {
      id: 4,
      title: "Dancing Queen,",
      heading: 'Netflix',
      thumbnaila: thumbnaila4,
      thumbnailaURL: 'https://vimeo.com/1095758597/5920620f41',
      vimeoId: '1095758597',
      vimeoHash: '5920620f41',
      description: "Doc-series following Justin Johnson, as he trys to run his award-winning dance school in rural Texas while also balancing life as drag superstar Alyssa Edwards (Ru Paul’s Dragrace)."
    },
    {
      id: 5,
      title: "NXIVM: Self help or Sex Cult,",
      heading: 'E!',
      thumbnaila: thumbnaila5,
      thumbnailaURL: 'https://vimeo.com/1095758653/46790dd959',
      vimeoId: '1095758653',
      vimeoHash: '46790dd959',
      description: "Excerpts of one of several episodes I edited of the 2021 reboot of The E! True Hollywood Story - an in-depth investigation of Nexium and the cult’s leader Keith Ranieri."
    },
    {
      id: 6,
      title: "Young Guns,",
      heading: 'GO90',
      thumbnaila: thumbnaila6,
      thumbnailaURL: 'https://vimeo.com/1095758961/d614aa1925',
      vimeoId: '1095758961',
      vimeoHash: 'd614aa1925',
      description: "Development materials for a doc series about a gang of outlaw kids in rural Montana. I worked on all episodes of the series."
    },
    
  ];
 const VideoEntry = ({ video, isReversed, index }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const openVideoModal = () => {
    setIsModalOpen(true);
    setIsLoading(true); // Reset loading state every time modal opens
  };

  const closeVideoModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-8 mb-16`}>
        <div className="w-full lg:w-1/2">
          <div onClick={openVideoModal} className="block cursor-pointer">
            <div className="relative group">
              <div className="w-full h-64 bg-gray-800 rounded-lg flex items-center justify-center overflow-hidden">
                <Play className="w-16 h-16 text-white group-hover:scale-110 transition-transform duration-300" style={{ zIndex: '30' }} />
              </div>
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors rounded-lg">
                <img
                  src={video.thumbnaila}
                  alt={video.title}
                  className="w-full h-full object-cover rounded-lg transition-transform duration-300"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/2">
          <h3 className="text-2xl font-bold mb-4 text-white otherfonts">{video.upperHeading?video.upperHeading:''} <i>{video.title}</i> {video.heading}</h3>
          <p className="text-gray-300 text-lg leading-relaxed otherfonts">
            {video.description}
          </p>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
          <div className="relative w-[90%] max-w-4xl aspect-video">
            
            {/* Loader */}
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50 rounded-lg">
                <div className="loader border-t-4 border-white rounded-full w-12 h-12 animate-spin"></div>
              </div>
            )}

            {/* Vimeo iframe */}
            <iframe
              src={`https://player.vimeo.com/video/${video.vimeoId}?h=${video.vimeoHash}&autoplay=1`}
              className="w-full h-full rounded-lg"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              onLoad={() => setIsLoading(false)}
            ></iframe>

            {/* Close Button */}
            <button
              onClick={closeVideoModal}
              className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-80 transition z-50"
            >
              <X size={24} />
            </button>
          </div>
        </div>
      )}
    </>
  );
};



  const realityVideos = [
    {
      id: 7,
      title: "Real Housewives of New York City,",
      heading: 'Bravo',
      thumbnaila: thumbnaila7,
      thumbnailaURL: 'https://vimeo.com/1095758703/c5e24e659c',
      vimeoId: '1095758703',
      vimeoHash: 'c5e24e659c',
      description: "Scenework from the most recent season 15, of the iconic Real Housewives franchise. I did extensive work over 9 episodes in seasons 14 and 15."
    },
    {
      id: 8,
      title: "Southern Charm,",
      heading: 'Bravo',
      thumbnaila: thumbnaila8,
      thumbnailaURL: 'https://vimeo.com/1095758731/24c695d834',
      vimeoId: '1095758731',
      vimeoHash: '24c695d834',
      description: "Scenework from the most recent season 10, of the popular Bravo franchise. I edited 5 episodes."
    },
    {
      id: 9,
      title: "Siesta Key,",
      heading: 'MTV',
      thumbnaila: thumbnaila9,
      thumbnailaURL: 'https://vimeo.com/1095758786/02f22fde16',
      vimeoId: '1095758786',
      vimeoHash: '02f22fde16',
      description: "Work from season 3 of this high production value, Emmy nominated docu-soap. 10 episodes."
    },
    {
      id: 10,
      title: "Below Deck,",
      heading: 'Bravo',
      thumbnaila: thumbnaila10,
      thumbnailaURL: 'https://vimeo.com/1095758527/2964869bca',
      vimeoId: '1095758527',
      vimeoHash: '2964869bca',
      description: "Excerpts from season 9 of the Emmy winning reality franchise. 11 episodes."
    },
    {
      id: 11,
      title: "Tidying Up With Marie Kondo,",
      heading: 'Netflix',
      thumbnaila: thumbnaila11,
      thumbnailaURL: 'https://vimeo.com/1095758630/983fe64cf8',
      vimeoId: '1095758630',
      vimeoHash: '983fe64cf8',
      description: "Clips from the formatted Emmy nominated reality series. I worked on all episodes."
    },
    {
      id: 12,
      title: "Vanderpump Rules,",
      heading: 'Bravo',
      thumbnaila: thumbnaila12,
      thumbnailaURL: 'https://vimeo.com/1095758913/91386f4f56',
      vimeoId: '1095758913',
      vimeoHash: '91386f4f56',
      description: "Scenework from the pivotal episode “The Bitch Slap,” from season 2 of the Emmy nominated series. I did extensive work on 9 other episodes including the season finale."
    }
  ]

  // const VideoEntry = ({ video, isReversed, index }) => (
  //   // <div className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-8 mb-16`}>
  //   //   <div className="w-full lg:w-1/2">
  //   //   <a href={video.thumbnailaURL} target="_blank" rel="noopener noreferrer" className="block">
  //   //     <div className="relative group cursor-pointer">
  //   //       <div className="w-full h-64 bg-gray-800 rounded-lg flex items-center justify-center overflow-hidden">
  //   //         <Play className="w-16 h-16 text-white group-hover:scale-110 transition-transform duration-300" style={{zIndex:'30'}} />
  //   //       </div>
  //   //       <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors rounded-lg">
  //   //       <img
  //   //         src={video.thumbnaila}
  //   //         alt={video.title}
  //   //         className="w-full h-full object-cover rounded-lg transition-transform duration-300 "
  //   //       />
  //   //       </div>
  //   //     </div>
  //   //     </a>
  //   //   </div>
  //   //   <div className="w-full lg:w-1/2">
  //   //     <i><h3 className="text-2xl font-bold mb-4 text-white mywork">{video.title}</h3></i>
  //   //     <p className="text-gray-300 text-lg leading-relaxed otherfonts">{video.description}</p>
  //   //   </div>
  //   // </div>
  //   <>
  //     <div className={`flex flex-col ${isReversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-8 mb-16`}>
  //       <div className="w-full lg:w-1/2">
  //         <div onClick={openVideoModal} className="block cursor-pointer">
  //           <div className="relative group">
  //             <div className="w-full h-64 bg-gray-800 rounded-lg flex items-center justify-center overflow-hidden">
  //               <Play className="w-16 h-16 text-white group-hover:scale-110 transition-transform duration-300" style={{ zIndex: '30' }} />
  //             </div>
  //             <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors rounded-lg">
  //               <img
  //                 src={video.thumbnaila}
  //                 alt={video.title}
  //                 className="w-full h-full object-cover rounded-lg transition-transform duration-300"
  //               />
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="w-full lg:w-1/2">
  //         <i><h3 className="text-2xl font-bold mb-4 text-white mywork">{video.title}</h3></i>
  //         <p className="text-gray-300 text-lg leading-relaxed otherfonts">{video.description} {`https://player.vimeo.com/video/${video.vimeoId}?h=${video.vimeoHash}&autoplay=1`}</p>
  //       </div>
  //     </div>

  //     {/* Modal */}
  //     {isModalOpen && (
  //       <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
  //         <h1>Hello world this is modal</h1>
  //         <div className="relative w-[90%] max-w-4xl aspect-video">
  //           <iframe
  //             src={`https://player.vimeo.com/video/${video.vimeoId}?h=${video.vimeoHash}&autoplay=1`}
  //             className="w-full h-full rounded-lg"
  //             frameBorder="0"
  //             allow="autoplay; fullscreen; picture-in-picture"
  //             allowFullScreen
  //           ></iframe>

  //           {/* Close Button */}
  //           <button
  //             onClick={closeVideoModal}
  //             className="absolute top-2 right-2 text-white bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-80 transition"
  //           >
  //             <X size={24} />
  //           </button>
  //         </div>
  //       </div>
  //     )}
  //   </>
  // )

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Navigation */}
      {/* <nav className="fixed top-0 w-full bg-black/90 backdrop-blur-sm z-50 border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="text-xl font-bold text-white">Christopher Peacock | Television Editor</div>
            <div className="hidden md:flex space-x-8">
              <a href="#home" className="text-white hover:text-blue-400 transition-colors">Home</a>
              <a href="#work" className="text-white hover:text-blue-400 transition-colors">Work</a>
              <a href="#credits" className="text-white hover:text-blue-400 transition-colors">Credits</a>
              <a href="#about" className="text-white hover:text-blue-400 transition-colors">About</a>
              <a href="#contact" className="text-white hover:text-blue-400 transition-colors">Contact</a>
            </div>
          </div>
        </div>
      </nav> */}
      <Navbar />
      {/* Hero Section with Image Loop */}
      <section id="home" className="hero-image-loop justify-center" style={{ display: 'flex' }}>
        {/* {heroImages.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Hero ${index + 1}`}
            className={`hero-image ${index === currentImageIndex ? 'active' : ''}`}
          />
        ))} */}
        <HeroSlider images={heroImages} />
        <div className="hero-overlay"></div>
        <div className="hero-content absolute inset-0 flex items-center justify-center" style={{ alignSelf: 'center' }}>
          <div className="text-center mywork">
            <h1 className="text-6xl md:text-8xl font-bold mb-4 text-white">
              Christopher Peacock
            </h1>
            <h2 className="text-6xl md:text-8xl font-bold text-white">
              Editor
            </h2>
          </div>
        </div>
      </section>

      {/* Work Section */}
      <section id="work" className="py-20 px-4 sm:px-6 lg:px-8 bg-black">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-20 text-white mywork">Work</h2>

          {/* Documentary Series */}
          <div className="mb-24">
            <h3 className="text-4xl font-bold mb-16 text-white mywork">Documentary Series</h3>
            {documentaryVideos.map((video, index) => (
              <VideoEntry
                key={video.id}
                video={video}
                isReversed={index % 2 === 1}
                index={index}
              />
            ))}
          </div>

          <div>
            <h3 className="text-4xl font-bold mb-16 text-white mywork ">Reality</h3>
            {realityVideos.map((video, index) => (
              <VideoEntry 
                key={video.id} 
                video={video} 
                isReversed={index % 2 === 1} 
                index={index}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Credits Section */}
      <section
        id="credits"
        className="py-40 px-4 sm:px-6 lg:px-8 relative min-h-screen bg-remover"
        style={{
          backgroundImage: `url(${networkBg})`,
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="max-w-4xl mx-auto text-center relative z-10" style={{ paddingTop: '250px', paddingBottom: '250px' }}>
          <h2 className="text-5xl font-bold mb-12 text-white mywork">Credits</h2>
          <div className="text-lg text-gray-300 leading-relaxed space-y-6">
            <div className="mt-8">
              <a
                href="https://www.imdb.com/name/nm2422496/?ref_=nv_sr_srsg_0_tt_0_nm_8_in_0_q_chris%2520peacoc"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-3 bg-yellow-600 hover:bg-yellow-700 text-black font-semibold rounded-lg transition-colors duration-300"
              >
                View IMDb Profile
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-black">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-16 text-white mywork">Bio</h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="flex justify-center">
              <img
                src={bioPhoto}
                alt="Television Editor Portrait"
                className=" object-cover shadow-2xl"
                style={{ height: '100%', width: '100%' }}
              />
            </div>
            <div className="text-lg text-gray-300 leading-relaxed space-y-2 otherfonts">
              <p>
                I’m a television editor and storyteller with over 20 years of experience across long-form documentary and reality television, and short form such as music videos and sizzle reels. I’ve cut everything from high-stakes docuseries to unscripted comedy formats, and across all genres, one thing remains constant: my focus on story. As a trusted “Preditor” (Producer/Editor), I’m often brought in to craft episodes from the ground up — shaping structure, tone, and emotional impact with minimal supervision.
              </p>
              <p>
                My editing style is cinematic, emotionally driven, and always designed to captivate. I stay current by absorbing the best of what I see in great films and series, bringing fresh creative touches to every project — but story and character always come first
              </p>
              <p>
                In addition to editing, I’m the co-founder of Parallax Entertainment, a development company represented by The Gersh Agency. We sold <i>The Program: Prison Detox</i> to Discovery, which was nominated for Best Docu-Reality Series at Realscreen 2023, and we’re currently developing several new titles. I’ve cut dozens of development sizzles and know exactly what networks are looking for.
              </p>
              <p>
                I’m available for editing work in television and short-form storytelling, and I’m especially interested in emerging formats — including branded content. I also consult on sizzle reels and pitch development.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8 bg-black">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-16 text-white mywork">Get In Touch</h2>
          {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-12"> */}
            <div>
              {/* <h3 className="text-2xl font-semibold mb-6 text-white mywork">Get In Touch</h3> */}
              <div className="text-center" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div className="flex items-center">
                  <Mail className="w-5 h-5 text-blue-400 mr-3" />
                  <span className="text-gray-300"><a href="mailto:chris@editorcp.tv" className="text-gray-300 hover:underline">
                    chris@editorcp.tv
                  </a></span>
                </div>
                {/* <div className="flex items-center">
                  <Phone className="w-5 h-5 text-blue-400 mr-3" />
                  <span className="text-gray-300">+1 (555) 123-4567</span>
                </div> */}
                <div className="flex items-center">
                  <MapPin className="w-5 h-5 text-blue-400 mr-3" />
                  <span className="text-gray-300">Los Angeles, CA</span>
                </div>
              </div>
            </div>
            <div>
              {/* <form onSubmit={handleSubmit} className="space-y-4">
                <Input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="bg-gray-800 border-gray-600 text-white placeholder-gray-400"
                />
                <Input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="bg-gray-800 border-gray-600 text-white placeholder-gray-400"
                />
                <Textarea
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows={5}
                  className="bg-gray-800 border-gray-600 text-white placeholder-gray-400"
                />
                <Button 
                  type="submit" 
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white"
                >
                  Send Message
                </Button>
              </form> */}
            </div>
          {/* </div> */}
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 sm:px-6 lg:px-8 border-t border-gray-800 bg-black">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-gray-400 otherfonts">
            © 2025 Christopher Peacock. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  )

}

export default App;
